<template>
  <div class="dropup" v-click-outside="closeSubMenu">
    <div
        class="dropdown-toggle"
        data-toggle="dropdown"
        @click="openSubMenu"
        :class="{ 'color-black': selectedMainTabClientTable === 'TOT' }"
    >
      <!--      'no-open' : !CheckUserPermission([1, 2, 3,4,5,12])-->
      <div
          class="arrow"
          :class="{ 'color-black': selectedMainTabClientTable === 'TOT' }"
          v-if="!ifOpenedSubMenu"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="toggle-left-side s-first">
        <span
        >{{ getMenuTitle(selectedCalendar, selectedMainTabClientTable) }}
        </span>
      </div>
      <div
          class="toggle-left-side numInPercents"
          v-tooltip="{
          placement: 'right',
          // content: kReFormatter(getStatsByTitle(selectedMainTabClientTable)),
          content: getStatsByTitleWithOutK(selectedMainTabClientTable),
          show: selectedMainTabClientTable == 'total'
        }"
      >
        <span>{{ getStatsByTitle(selectedMainTabClientTable) }}</span>
      </div>
      <div v-if="ifOpenedSubMenu" class="right-add">
        <span v-if="ifOpenedSubMenu"
        >{{ getNumInPercent(selectedMainTabClientTable) }}%</span
        >
      </div>
      <!--      <span class="tab-pagination-left" v-show="tabPaginationIndex > 0">-->
      <!--        <i class="fa fa-chevron-left"-->
      <!--           @click="tabPagination($event,'left')"></i>-->
      <!--      </span>-->
      <!--      <span class="tab-pagination-right" v-show="tabPaginationIndex != getTabList(mainTabsList).length"> <i class="fa fa-chevron-right"-->
      <!--                @click="tabPagination($event,'right')"-->
      <!--      ></i> </span>-->
      <div
          class="sub-menu-ms-btn"
          @click="openSubMs($event, selectedMainTabClientTable)"
          v-if="
          (!ifOpenedSubMenu && selectedMainTabClientTable === 'NI') ||
            selectedMainTabClientTable === 'BN'
        "
      >
        <span>
          <i class="fas fa-bars"></i>
        </span>
      </div>
    </div>
    <div class="dropdown-menu sub-menu-dropup">
      <!--      <p class="tab-sub-menu-btn" role="button">-->
      <!--        <span class="dropdown-item-left"-->
      <!--          >Total:-->
      <!--          <span class="numInPercents">{{-->
      <!--            kFormatter(-->
      <!--              clientsTableStatsObject.active_group_count +-->
      <!--                clientsTableStatsObject.na_group_count +-->
      <!--                clientsTableStatsObject.ni_group_count +-->
      <!--                clientsTableStatsObject.bn_group_count +-->
      <!--                clientsTableStatsObject.tier +-->
      <!--                clientsTableStatsObject.ended +-->
      <!--                clientsTableStatsObject.merged-->
      <!--            )-->
      <!--          }}</span></span-->
      <!--        >-->
      <!--      </p>-->
      <button
          class="dropdown-item btn btn-block"
          v-for="tab in getTabList(mainTabsList)"
          :class="getBtnClass(tab.name)"
          :key="tab.id"
          @click="setTabClientsTable(tab.name, tab.alias)"
      >
        <span class="dropdown-item-left">{{
            tab.name === "CLIENTS" ? "ACT" : tab.name
          }}</span>
        <span class="dropdown-item-center">{{
            getStatsByTitle(tab.name)
          }}</span>
        <span class="dropdown-item-right"
        >{{ getNumInPercent(tab.name)
          }}<span v-if="tab.name !== 'TOT'">%</span></span
        >
        <span
            class="dropdown-item-right loader-wrapper"
            v-if="tab.name === 'TOT' && fetchingStats"
        >
          <div class="loader"></div>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import calendarCheck from "../../../../../mixins/tags/calendarCheck";
import TotalModeCheck from "../../../../../mixins/tags/TotalModeCheck";
import FilterUsersByEmail from "../../../../../mixins/user/auth/FilterUsersByEmail";
import apiClientCreator from "../../../../../helpers/api/request";
import {mapGetters, mapState} from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "CalendarOrdersSubMenu",
  mixins: [
    UsersPermissionCheck,
    FilterUsersByEmail,
    calendarCheck,
    TotalModeCheck
  ],
  props: {
    mainTabsList: {
      type: Array,
      required: true
    },
    selectedCalendar: {
      type: String,
      required: true
    },
    innerCssVars: {
      type: Object
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "filterClientId",
      "filterCaMissed",
      "filterClientCall",
      "enlargeCompanyTable",
      "AssigmentChoseAll",
      "LastModChoseTimeForChart",
      "LastModChoseFromStatsTable",
      "updateAfterCongrats",
      "dataFromFavs",
      "selectedMainCalendar",
      "filterDepStatus",
      "graphDataToTable",
      "scDataToTable",
      "regCalFilterNoDate",
      "generalChartFilter",
      "chartsMainView",
      "dynamicChartUsers",
      "dynamicChartDates",
      "generalQueryObject",
      "clientsTableSelectedMainTab",
      "clientsTableSelectedTab",
      "clientsTableStatsObject",
      "calNameForCountries",
      "loading"
    ])
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      selectedMainTabClientTable: "CLIENTS",
      stats: this.clientsTableStatsObject,
      ifOpenedSubMenu: false,
      ifOpenedSubMs: false,
      selectedSubMenuMs: null,
      tabPaginationIndex: 0,
      fetchingStats: false
    };
  },
  methods: {
    closeSubMenu() {
      this.ifOpenedSubMenu = false;
      this.selectedSubMenuMs = null;
    },
    openSubMs(e, tab) {
      e.stopPropagation();
      this.ifOpenedSubMs = !this.ifOpenedSubMs;
      this.selectedSubMenuMs = tab;
      // $(e.target).toggleClass("fa-times");
      this.$store.commit("clients/setClientsTableCalendarSubMenuSubMs", {
        opened: this.ifOpenedSubMs,
        subMsType: this.selectedSubMenuMs
      });
    },
    tabPagination(e, direction) {
      e.stopPropagation();
      const tempTabList = this.mainTabsList.filter(tab => {
        return (
            tab.name !== "RECENT" &&
            tab.name !== "USERS" &&
            tab.name !== "BROKERS" &&
            tab.name !== "AFFILIATION"
        );
      });
      let index = tempTabList.findIndex(
          item => item.name === this.selectedMainTabClientTable
      );
      if (direction === "left") {
        index -= 1;
      }
      if (direction === "right") {
        index += 1;
      }
      this.tabPaginationIndex = index;

      // this.ifOpenedSubMenu = true

      this.setTabClientsTable(
          tempTabList[index].name,
          tempTabList[index].alias
      );
    },
    openSubMenu() {
      this.ifOpenedSubMenu = !this.ifOpenedSubMenu;
      this.selectedSubMenuMs = null;
    },
    kFormatter: function(num) {
      if (num > 0) {
        return Math.abs(num) > 999
            ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
            : Math.sign(num) * Math.abs(num);
      }
      return "";
    },
    // Function converts kFormat to number || Gets string || returns number
    kReFormatter: function(kNum) {
      if (kNum[kNum.length - 1] === "k") {
        // Check if last character is 'k'
        return kNum.slice(0, -1) * 1000;
      }
      return "";
    },
    calculateNumInPercent(statsItem) {
      return (
          (
              (statsItem * 100) /
              (this.clientsTableStatsObject.na_group_count +
                  this.clientsTableStatsObject.ni_group_count +
                  this.clientsTableStatsObject.bn_group_count +
                  this.clientsTableStatsObject.tier +
                  this.clientsTableStatsObject.active_group_count +
                  this.clientsTableStatsObject.ended +
                  this.clientsTableStatsObject.merged)
          )
              //  this.clientsTableStatsObject.dwa
              .toFixed(0)
      );
    },
    getNumInPercent(tabTitle) {
      switch (tabTitle) {
        case "CLIENTS":
          return this.calculateNumInPercent(
              this.clientsTableStatsObject.active_group_count
          );
        case "NR":
          return this.calculateNumInPercent(
              this.clientsTableStatsObject.na_group_count
          );
        case "NI":
          return this.calculateNumInPercent(
              this.clientsTableStatsObject.ni_group_count
          );
        case "BN":
          return this.calculateNumInPercent(
              this.clientsTableStatsObject.bn_group_count
          );
        case "NU":
          return this.calculateNumInPercent(this.clientsTableStatsObject.tier);
        case "END":
          return this.calculateNumInPercent(this.clientsTableStatsObject.tier);
        case "MERG":
          return this.calculateNumInPercent(this.clientsTableStatsObject.tier);
          // case "DWA":
          //   return this.calculateNumInPercent(this.clientsTableStatsObject.dwa);
      }
    },
    getMenuTitle(selectedCalendar, selectedMainTabClientTable) {
      if (selectedCalendar === "AS") {
        return "AGT";
      }
          // else if (selectedCalendar === "DP" || selectedCalendar === "LD") {
          //   return "TOT";
      // }
      else if (selectedMainTabClientTable === "CLIENTS") {
        // if (!this.checkIfCalendarSelected() && this.checkIfTotalMode()) {
        //   return "TOT";
        // }
        // else {
        return "ACT";
        // }
      } else {
        return selectedMainTabClientTable;
      }
    },
    getStatsByTitle(tabTitle) {
      let nf = new Intl.NumberFormat();
      let tempValue = this.clientsTableStatsObject.active_group_count;
      switch (tabTitle) {
        case "CLIENTS":
          // return this.kFormatter(
          //   this.clientsTableStatsObject.active_group_count
          // );
          // if (
          //   !this.checkIfCalendarSelected() &&
          //   // this.checkIfTotalMode() &&
          //   !this.ifOpenedSubMenu &&
          //   !this.generalQueryObject.hasOwnProperty("is_new")
          // ) {
          //   return this.kFormatter(
          //     this.clientsTableStatsObject.active_group_count +
          //       this.clientsTableStatsObject.na_group_count +
          //       this.clientsTableStatsObject.ni_group_count +
          //       this.clientsTableStatsObject.bn_group_count +
          //       this.clientsTableStatsObject.tier +
          //       this.clientsTableStatsObject.ended +
          //       this.clientsTableStatsObject.merged
          //   );
          // }
          // if (
          //   this.selectedCalendar === "DP" ||
          //   this.selectedCalendar === "LD"
          // ) {
          //
          //   tempValue += this.clientsTableStatsObject.ended;
          // }

          return nf.format(tempValue);
        case "NR":
          return nf.format(this.clientsTableStatsObject.na_group_count);
        case "NI":
          // return this.kFormatter(this.clientsTableStatsObject.ni_group_count);
          // return this.clientsTableStatsObject.ni_group_count;
          return nf.format(this.clientsTableStatsObject.ni_group_count);
        case "BN":
          return nf.format(this.clientsTableStatsObject.bn_group_count);
        case "NU":
          return nf.format(this.clientsTableStatsObject.tier);
        case "END":
          return nf.format(this.clientsTableStatsObject.ended);
        case "MERG":
          return nf.format(this.clientsTableStatsObject.merged);
        case "TOT":
          return this.kFormatter(
              this.clientsTableStatsObject.active_group_count +
              this.clientsTableStatsObject.na_group_count +
              this.clientsTableStatsObject.ni_group_count +
              this.clientsTableStatsObject.bn_group_count +
              this.clientsTableStatsObject.tier +
              this.clientsTableStatsObject.ended +
              this.clientsTableStatsObject.merged
          );
          // case "DWA":
          //   return nf.format(this.clientsTableStatsObject.dwa);
      }
    },
    getStatsByTitleWithOutK(tabTitle) {
      let nf = new Intl.NumberFormat();
      let tempValue = this.clientsTableStatsObject.active_group_count;
      switch (tabTitle) {
        case "TOT":
          return (
              this.clientsTableStatsObject.active_group_count +
              this.clientsTableStatsObject.na_group_count +
              this.clientsTableStatsObject.ni_group_count +
              this.clientsTableStatsObject.bn_group_count +
              this.clientsTableStatsObject.tier +
              this.clientsTableStatsObject.ended +
              this.clientsTableStatsObject.merged
          );
        default:
          return "";
      }
    },
    setTabClientsTable(tabName, tabAlias) {
      if (this.selectedCalendar !== "SC-F") {
        this.selectedMainTabClientTable = tabName;
        this.emitSetClientsTableSelectedTab(tabAlias);
        this.ifOpenedSubMenu = false;
        this.selectedSubMenuMs = null;
        this.$emit("setGroupCalendar", {
          class: this.getBtnClass(tabName),
          tabName: tabName
        });
      } else {
        if (tabAlias !== "total") {
          this.selectedMainTabClientTable = tabName;
          this.emitSetClientsTableSelectedTab(tabAlias);
          this.ifOpenedSubMenu = false;
          this.selectedSubMenuMs = null;
          this.$emit("setGroupCalendar", {
            class: this.getBtnClass(tabName),
            tabName: tabName
          });
        }
      }
    },
    emitSetClientsTableSelectedTab(tabAlias) {
      if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
        this.$store.commit("clients/setClientsTableSelectedMainTab", tabAlias);
      } else {
        if (tabAlias === "ended") {
          this.$store.commit(
              "clients/setClientsTableSelectedMainTab",
              tabAlias
          );
        }
      }
    },
    getTabList(tabList) {
      if (
          this.selectedMainTabClientTable === "CLIENTS" &&
          this.checkIfCalendarSelected() &&
          this.checkIfTotalMode()
      ) {
        if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
          return tabList
              .filter(tab => {
                return (
                    tab.name !== "RECENT" &&
                    tab.name !== "USERS" &&
                    tab.name !== "BROKERS" &&
                    tab.name !== "AFFILIATION" &&
                    tab.name !== "DWA"
                );
              })
              .reverse();
        } else {
          return tabList
              .filter(tab => {
                return tab.name === "END";
              })
              .reverse();
        }
      } else {
        if (this.CheckUserPermission([1, 2, 3, 4, 5, 12])) {
          return tabList
              .filter(tab => {
                return (
                    tab.name !== this.selectedMainTabClientTable &&
                    tab.name !== "RECENT" &&
                    tab.name !== "USERS" &&
                    tab.name !== "BROKERS" &&
                    tab.name !== "AFFILIATION" &&
                    tab.name !== "DWA"
                );
              })
              .reverse();
        } else {
          return tabList
              .filter(tab => {
                return (
                    (tab.name !== this.selectedMainTabClientTable &&
                        tab.name === "END") ||
                    (tab.name === "CLIENTS" &&
                        tab.name !== this.selectedMainTabClientTable)
                );
              })
              .reverse();
        }
      }
    },
    getBtnClass(tabName) {
      let style = "btn-success-header";
      switch (tabName) {
        case "NR":
          style = "btn-danger-header";
          break;
        case "NI":
          style = "btn-light-gray";
          break;
        case "BN":
          style = "btn-dark";
          break;
        case "NU":
          style = "btn-primary-header";
          break;
        case "END":
          style = "btn-success-header";
          break;
        case "MERG":
          style = "btn-secondary";
          break;
        case "DWA":
          style = "btn btn-info-header";
          break;
        case "TOT":
          style = "btn btn-total-header";

          // if(this.checkIfCalendarSelected()){
          //   style = "btn btn-total-header";
          // } else{
          //   style = "btn btn-total-header non-clickable";
          // }
          break;
      }
      return style;
    }
  },
  watch: {
    selectedMainTabClientTable: function() {
      this.$store.commit("clients/setCalNameForCountries", {
        calName: this.selectedMainTabClientTable,
        color: this.innerCssVars["--br-color"]
      });
    },
    selectedCalendar(selectedCalendar) {
      if (
          selectedCalendar === "SC-F" &&
          this.selectedMainTabClientTable === "TOT"
      ) {
        this.setTabClientsTable("CLIENTS", "clients");
      }
      //       switch (selectedCalendar) {
      // case 'SC-F':
      //   this.setTabClientsTable('CLIENTS', "clients")
      //               break;
      //         case 'CA-F':
      //           this.setTabClientsTable('CLIENTS', "clients")
      //           break;
      //       }
    },
    ifOpenedSubMenu() {
      this.$store.commit(
          "clients/setClientsTableCalendarSubMenuOpened",
          this.ifOpenedSubMenu
      );
    },
    clientsTableSelectedMainTab() {
      if (this.clientsTableSelectedMainTab === "total") {
        this.selectedMainTabClientTable = "TOT";
      }
      if (this.clientsTableSelectedMainTab === "clients") {
        this.selectedMainTabClientTable = "CLIENTS";
      }
      if (this.clientsTableSelectedMainTab === "na") {
        this.selectedMainTabClientTable = "NR";
      }
      if (this.clientsTableSelectedMainTab === "ni") {
        this.selectedMainTabClientTable = "NI";
      }
      if (this.clientsTableSelectedMainTab === "bn") {
        this.selectedMainTabClientTable = "BN";
      }
      if (this.clientsTableSelectedMainTab === "t4") {
        this.selectedMainTabClientTable = "NU";
      }
      if (this.clientsTableSelectedMainTab === "ended") {
        this.selectedMainTabClientTable = "END";
      }
    },
    selectedSubMenuMs() {
      if (this.selectedSubMenuMs === null) {
        this.$store.commit("clients/setClientsTableCalendarSubMenuSubMs", {
          opened: this.ifOpenedSubMs,
          subMsType: this.selectedSubMenuMs
        });
      }
    }
  },
  mounted() {
    $(document).ready(function() {
      // $("#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4").click(function() {
      //   $(this).toggleClass("open");
      // });
      $(".sub-menu-ms-opener").click(function() {
        $(this).toggleClass("open");
      });
    });
  }
};
</script>

<style scoped>
.dropdown-item {
  height: 35px;
  padding: 8px 0px;
  margin: 0px;
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-toggle {
  text-decoration: none;
  color: white;
  display: flex;
  background-color: inherit;
  /*height: 58px;*/
}

.toggle-left-side {
  margin-right: 14px;
  /*margin-right: 27px;*/
}
.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  /*margin-right: 36px;*/
}
.numInPercents {
  /*padding-left: 5px;*/
  /*color: #cbc26f !important;*/
  /*color: #ab9b0d !important;*/
}

.dropdown-menu .ul-cals {
  border-radius: 0px;
  margin-left: -14px;
  margin-right: 5px;
  /*top: 60%!important;*/
}

.sub-menu-dropup {
  left: -9px;
  bottom: 30px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 155px;
  border-radius: 0px;
  padding: 0px;
}
.tab-sub-menu-btn {
  text-decoration: none;
  color: #333;
  padding: 5px 0px 0px 10px;
  margin-bottom: 5px;
  font-weight: bold;
}
.dropdown-item-left {
  margin-left: 23px;
  /*float: left;*/
  flex: 2;
  font-weight: 500;
}
.dropdown-item-right {
  flex: 1;

  /*float: right;*/
  margin-right: 5px;
}
.dropdown-item-center {
  /*margin-left: -6px;*/
  flex: 2;
}
.dropup {
  width: 100%;
  height: 100%;
  /*padding-top: 9px;
  */
  display: flex;
  align-items: center;
}
.longTitleFontSize {
  /*font-size: 9px;*/
  /*margin-right: 5px;*/
  /*padding-top: 4px;*/
}

.btn-secondary {
  color: #ffffff;
  background-color: #777;
  border-color: #555;
}
.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary:active,
.btn-secondary.active,
.open .dropdown-toggle.btn-secondary {
  color: #ffffff;
  background-color: #888;
  border-color: #444;
}

.btn-dark {
  color: #fff;
  background-color: #000000;
  border-color: #343a40;
}
.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active,
.open .dropdown-toggle.btn-dark {
  color: #ffffff;
  background-color: #000000;
  border-color: #444;
}
.btn-total-header {
  color: #546e7a;
  background-color: white;
  border-color: #546e7a;
}
.btn-total-header:hover,
.btn-total-header:focus,
.btn-total-header:active,
.btn-total-header.active,
.open .dropdown-toggle.btn-total-header {
  color: #546e7a;
  background-color: white;
  border-color: #546e7a;
}
.btn-light-gray {
  color: #000000;
  background-color: #efefef;
  border-color: #efefef;
}
.btn-light-gray:hover,
.btn-light-gray:focus,
.btn-light-gray:active,
.btn-light-gray.active,
.open .dropdown-toggle.btn-light-gray {
  color: #000000;
  background-color: #f1f1f1;
  border-color: #f1f1f1;
}

.btn-danger-header {
  color: #ffffff;
  background-color: #c9302c;
  border-color: #ac2925;
}
.btn-danger-header:hover,
.btn-danger-header:focus,
.btn-danger-header:active,
.btn-danger-header.active,
.open .dropdown-toggle.btn-danger-header {
  color: #ffffff;
  background-color: #c9302c;
  border-color: #ac2925;
}

.btn-info-header {
  color: #ffffff;
  background-color: #2ba3cf;
  border-color: #33b5e5;
}
.btn-info-header:hover,
.btn-info-header:focus,
.btn-info-header:active,
.btn-info-header.active,
.open .dropdown-toggle.btn-info-header {
  color: #ffffff;
  background-color: #2ba3cf;
  border-color: #33b5e5;
}

.btn-primary-header {
  color: #ffffff;
  background-color: #286090;
  border-color: #204d74;
}
.btn-primary-header:hover,
.btn-primary-header:focus,
.btn-primary-header:active,
.btn-primary-header.active,
.open .dropdown-toggle.btn-primary-header {
  color: #ffffff;
  background-color: #286090;
  border-color: #204d74;
}

.btn-success-header {
  color: #ffffff;
  background-color: #008b00;
  border-color: #008b00;
}
.btn-success-header:hover,
.btn-success-header:focus,
.btn-success-header:active,
.btn-success-header.active,
.open .dropdown-toggle.btn-success-header {
  color: #ffffff;
  background-color: #008b00;
  border-color: #008b00;
}
.active-tab-class {
  margin-right: 6px !important;
}
.sub-menu-ms-btn {
  color: white;
  left: 41px;
  position: absolute;
  /* margin-left: -21px; */
}
.arrow {
  position: absolute;
  top: 2px;
  left: 1px;
  /*transform: translate(50%,50%);*/
  transform: rotate(180deg);
  visibility: hidden;
}

.arrow span {
  display: block;
  width: 5px;
  height: 5px;
  border-bottom: 1px solid white;
  border-right: 1px solid white;
  transform: rotate(45deg);
  margin: -10px;
}
.main-cal-div:hover .arrow span:nth-child(1) {
  animation: animate 2s infinite;
}
.main-cal-div:hover .arrow span:nth-child(2) {
  animation: animate 2s infinite;

  animation-delay: -0.2s;
}
.main-cal-div:hover .arrow span:nth-child(3) {
  animation: animate 2s infinite;

  animation-delay: -0.4s;
}
@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-5px, -5px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(5px, 5px);
  }
}
.main-cal-div:hover .arrow {
  visibility: visible;
}
.tab-pagination-left,
.tab-pagination-right {
  margin-right: 5px;
}
.tab-pagination-left:hover,
.tab-pagination-right:hover {
  color: #808080;
}
.s-first {
  margin-left: 15px;
  min-width: 37px;
  text-align: left;
  /*float: left;*/
}

.toggle-left-side.numInPercents {
  min-width: 35px !important;
  text-align: left;
}
.clients-margin {
  margin-right: 4px;
}
.right-add {
  height: 33px;
  position: absolute;
  /* width: 37px; */
  /* left: 63px; */
  /* right: -31px; */
  background-color: inherit;
  z-index: 1;
  padding: 7px;
  padding-left: 0px;
  top: 7px;
  border-radius: 0px 0px 5px 0px;
  width: 37px;
  /* left: 63px; */
  right: -30px;
}
.dropup .router-link.dropdown-toggle {
  background-color: inherit;
}

.dropup.open {
  background-color: inherit;
}
.color-black {
  /*color: #546e7a;*/
  color: #325869;
}
.arrow.color-black span {
  border-bottom: 1px solid #546e7a;
  border-right: 1px solid #546e7a;
}
.non-clickable {
  pointer-events: none;
  cursor: default !important;
}
.no-open {
  pointer-events: none;
}
.loader-wrapper {
  position: relative;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  margin-top: -4px;
}
</style>
